import {useIntl} from 'react-intl';


/**
 * Wrapper for react-intl formatMessage
 *
 * @param id {string} Message id
 * @param values {object} Values to set
 * @return {string} Translated message
 */
function useI18nMessage(id, values = {}) {

    const {formatMessage} = useIntl();

    return formatMessage({id}, values);
}


export default useI18nMessage;
